"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "cols-form tab-card-validation-face-component"
  }, [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("card", {
    staticClass: "card-detail-image biometric-validation-card"
  }, [_c("div", {
    staticClass: "dossie-validation"
  }, [_c("div", {
    staticClass: "dossie-validation__hero"
  }, [_c("div", {
    staticClass: "dossie-validation__media"
  }, [_vm.validationFace ? _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: _vm.validationFace
    }
  }) : _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: require("@/assets/images/avatar-default.png")
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "dossie-validation__summary"
  }, [_c("div", {
    staticClass: "dossie-validation__eyebrow"
  }, [_vm._v("\n                  Síntese do Processo\n                ")]), _vm._v(" "), _c("div", {
    staticClass: "dossie-validation__headline"
  }, [_c("div", [_c("h2", [_vm._v(_vm._s(_vm.summaryStatus.title))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.summaryStatus.description))])]), _vm._v(" "), _c("span", {
    class: ["tag", "dossie-validation__status-chip", _vm.summaryStatus.tagClass]
  }, [_c("b-icon", {
    attrs: {
      icon: _vm.summaryStatus.icon,
      size: "is-small"
    }
  }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.summaryStatus.tagLabel))])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "dossie-validation__meta"
  }, [_c("div", {
    staticClass: "dossie-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "clipboard-check",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Status do processo")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.processStatusLabel))])])], 1), _vm._v(" "), _c("div", {
    staticClass: "dossie-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "badge-account-outline",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Decisão automática")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.dossierDecisionLabel))])])], 1), _vm._v(" "), _vm.scoreFinal !== null ? _c("div", {
    staticClass: "dossie-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "chart-line",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Score final")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.scoreFinal))])])], 1) : _vm._e()])])]), _vm._v(" "), _c("section", {
    staticClass: "dossie-validation__section"
  }, [_c("div", {
    staticClass: "dossie-validation__section-header"
  }, [_c("div", {
    staticClass: "dossie-validation__section-title"
  }, [_c("b-icon", {
    attrs: {
      icon: "view-dashboard"
    }
  }), _vm._v(" "), _c("h3", [_vm._v("Painel consolidado")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "dossie-validation__grid"
  }, _vm._l(_vm.dossieHighlights, function (item) {
    return _c("div", {
      key: item.key,
      class: ["dossie-validation__item-card", "is-".concat(item.tone)]
    }, [_c("div", {
      staticClass: "dossie-validation__item-head"
    }, [_c("div", {
      staticClass: "dossie-validation__item-icon"
    }, [_c("b-icon", {
      attrs: {
        icon: item.icon
      }
    })], 1), _vm._v(" "), _c("span", {
      class: ["tag", "dossie-validation__item-tag", "is-".concat(item.tone)]
    }, [_vm._v("\n                      " + _vm._s(item.tag) + "\n                    ")])]), _vm._v(" "), _c("h4", [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(item.text))]), _vm._v(" "), item.helper ? _c("p", [_vm._v(_vm._s(item.helper))]) : _vm._e()]);
  }), 0)])])])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;